import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, List, ListItem, Divider, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { useUser } from '../../../userContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function Shippers() {

  const [displayWindowsShippers, setDisplayWindowsShippers] = useState(false);
  const [displayLinuxShippers, setDisplayLinuxShippers] = useState(false);
  const { userRegistrationDate } = useUser();
  const navigate = useNavigate();

  const formattedRegDate = (incDate) => {
      const date = new Date(incDate);
      date.setDate(date.getDate() + 45);
      return date.toString();
  }

  const regDt = formattedRegDate(userRegistrationDate);

  useEffect(() => {
      const fetchData = async () => {
          try {              
              const response = await fetch(`${process.env.REACT_APP_API}/options/Shippers`);
              if (!response.ok) {
                  toast.error(`HTTP error! status: ${response.status}`);
              } else {
                  const json = await response.json();
                  const resp = json.data;
                  resp.forEach( (shipper) => {
                      if (shipper.active) {
                          if (shipper.name.includes('Windows')) {
                              setDisplayWindowsShippers(true);
                          } else if (shipper.name.includes('Linux')) {
                              setDisplayLinuxShippers(true);
                          }
                      }
                  });
              }
          } catch (error) {
              toast.error(error);
          } 
      };

      fetchData();
  }, []);

  const handleWindowsClick = () => {    
    navigate('/installShippers');
  }

  const handleLinuxClick = () => {    
    navigate('/linuxShippers');
  }

  const handleCstWindowsClick = () => {    
    navigate('/installCstShippers');
  }

  const handleCstLinuxClick = () => {    
    navigate('/linuxCstShippers');
  }

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="Shippers"></PageHeader>
      </Box>
        <Box
          sx={{
            maxWidth: 1300,
            margin: 'auto',
            p: 3,
            mt: 5,
            border: '1px solid #ccc',
            boxShadow: 2,
            backgroundColor: '#1A1A1A',
          }}
        >
          <Typography sx={{fontSize: "12px"}} marginTop="-20px" marginLeft="-20px" padding={'0px'} fontWeight="bold">
            Shippers
          </Typography>
           <Divider
            sx={{
              borderColor: 'white',
              borderBottomWidth: '1px',
              margin: 'auto',
              marginLeft: '-25px',
              width: '1350px',
              marginBottom: '-10px',
            }}
          />
          <Typography sx={{fontSize: "12px"}} textAlign="center" marginLeft="-20px" marginRight="-20px" marginBottom="-20px" mt={2}>
            <Box
                sx={{          
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'left',
                  flexDirection: 'column',
                }}
              >
                <List>
                  { displayWindowsShippers &&
                    <>
                        <ListItem sx={{ fontSize: '12px' }}>
                              <Link component="button" color="#c1d4e7" disabled>
                                Download Windows Shippers Here
                              </Link>
                              
                          </ListItem>
                          <ListItem sx={{ fontSize: '12px', marginTop:"-5px", '&:hover': { cursor: 'pointer' } }}>
                            <Link underline="hover" color="#c1d4e7" onClick={handleWindowsClick}>
                                Windows Install Instructions
                            </Link>
                        </ListItem>
                    </>
                  } 
                  { displayLinuxShippers &&
                    <>
                        <ListItem sx={{ fontSize: '12px', marginTop:"-5px" }}>
                          <Link component="button" color="#c1d4e7" disabled>
                              Download RedHat/CentOS/OracleLinux Shippers Here
                          </Link>
                        </ListItem>
                        <ListItem sx={{ fontSize: '12px', marginTop:"-5px", '&:hover': { cursor: 'pointer' } }}>
                          <Link underline="hover" color="#c1d4e7" onClick={handleLinuxClick}>
                              RedHat/CentOS/OracleLinux Install Instructions
                          </Link>
                        </ListItem>                      
                    </>
                  }
                </List>
              </Box>
          </Typography>
        </Box>

        <Box
          sx={{
            width: '1300px',
            margin: 'auto',
            p: 3,
            mt: 5,
            border: '1px solid #ccc',
            boxShadow: 2,
            backgroundColor: '#1A1A1A',
          }}
        >
          <Typography sx={{fontSize: "12px"}} marginTop="-20px" marginLeft="-20px" padding={'0px'} fontWeight="bold">
            Active Response
          </Typography>
           <Divider
            sx={{
              borderColor: 'white',
              borderBottomWidth: '1px',
              margin: 'auto',
              marginLeft: '-25px',
              width: '1350px',
              marginBottom: '-10px'
            }}
          />
          <Typography sx={{fontSize: "12px"}} textAlign="center" marginLeft="-20px" marginRight="-20px" marginBottom="-20px" mt={2}>
            <Box
                sx={{          
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'left',
                  flexDirection: 'column',
                }}
              >
                <List>
                  { displayLinuxShippers &&
                    <>
                        <ListItem sx={{ fontSize: '12px' }}>
                            <Link component="button" color="#c1d4e7" disabled>
                              Download RedHat/CentOS/OracleLinux CST User Install Script Here
                            </Link>
                        </ListItem>
                        <ListItem sx={{ fontSize: '12px', marginTop:"-5px"}}>
                          <Link underline="hover" color="#c1d4e7" onClick={handleCstLinuxClick} sx={{ '&:hover': { cursor: 'pointer' } }}>
                              RedHat/CentOS/OracleLinux Install Instructions
                          </Link>
                        </ListItem>
                    </>
                  }

                  { displayWindowsShippers &&
                    <>
                        <ListItem sx={{ fontSize: '12px', marginTop:"-5px" }}>
                            <Link component="button" color="#c1d4e7" disabled>
                              Download Windows CST User Install Script Here
                          </Link>
                        </ListItem>
                        <ListItem sx={{ fontSize: '12px', marginTop:"-5px" }}>
                          <Link underline="hover" color="#c1d4e7" onClick={handleCstWindowsClick} sx={{ '&:hover': { cursor: 'pointer' } }}>
                              Windows Install Instructions
                          </Link>
                        </ListItem>
                    </>
                  } 
                </List>
              </Box>
          </Typography>
        </Box>

        <Box
          sx={{
            alignItems: 'center',
            justify: 'center',
            mt: 6
          }}
        ></Box>
            <Typography sx={{fontSize: "12px"}} align='center' marginBottom="-40px" fontWeight="bold">
              License Expires: {regDt}
            </Typography>
            <Typography sx={{fontSize: "12px" }} align='center' color='green' marginBottom="-15px" fontWeight="bold">
              License is good.
            </Typography>

        <Box
          sx={{
            maxWidth: 1300,
            margin: 'auto',
            p: 3,
            mt: 5,
            border: '1px solid #ccc',
            boxShadow: 2,
            backgroundColor: '#1A1A1A',
          }}
        >
          <Typography sx={{fontSize: "12px"}} marginTop="-20px" marginLeft="-20px" padding={'0px'} fontWeight="bold">
            Notice
          </Typography>
           <Divider
            sx={{
              borderColor: 'white',
              borderBottomWidth: '1px',
              margin: 'auto',
              marginLeft: '-25px',
              width: '1350px',
              marginBottom: '-10px'
            }}
          />
          <Typography sx={{fontSize: "12px"}} textAlign="center" marginLeft="-20px" marginRight="-20px" marginBottom="-20px" mt={2}>
            You are accessing a Canfield CyberDefense Group (CCG) Information System (IS) that is provided for CheckMate authorized use only.
            <br />
            By using this IS (which includes any software application attached to this IS), you consent to the following conditions:
            <br />
            The CCG routinely intercepts and monitors communications on this IS for purposes including, but not limited to, performance testing (PT), usage monitoring (UM), system health and status (SMS), and personnel misconduct (PM).
            <br />
            At any time, CCG may inspect and seize data related to configuration, usage, and performance stored on this IS.
            <br />
            Communications usage, or data stored on, this IS related to configurations and operations are not private, are subject to routine monitoring, interception, and search, and may be disclosed or used for any authorized purpose.
            <br />
            This IS includes security measures (e.g., authentication and access controls) to protect CCG interests not for your personal benefit or privacy.
          
          </Typography>
        </Box>
    </Container>
  );
}


